import React, { useContext, useEffect, useState } from "react";
import {
  Tabs,
  Tab,
  Container,
  makeStyles,
  Box,
} from "@material-ui/core";
import { ApplicationSummaryPageContext } from "./ApplicationSummaryPage";
import { Alert } from "@material-ui/lab";
import TabPanel from "legacy-components/tab-panel/TabPanel";
import ApplicationOverviewTab from "./ApplicationOverviewTab";
import GrantTypesForm from "../../../apis/components/grant-types/GrantTypeForm";
import { SubscriptionsList } from "../../components/SubscriptionsList";
import { ConsentForm } from "./components/ConsentForm";
import { useAuthorizer } from "modus/components/authorizer/Authorizer";

const useStyles = makeStyles((theme) => ({
  root: { flexGrow: 1 },
  tabs: { borderBottom: "none" },
  container: { margin: "0px", padding: "0px" },
  tab: {
    maxWidth: "400px",
    minWidth: "50px",
    padding: "12px 32px 11px 32px",
    height: "47px",
    whiteSpace: "inherit",
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  tabPanel: {
    margin: "0px",
    padding: "0px",
    marginTop: "20px"
  },
}));

interface ApplicationSummaryDetailViewProps {
  reloadApplication: () => void;
}

const ApplicationSummaryDetailView: React.FC<
  ApplicationSummaryDetailViewProps
> = ({reloadApplication}) => {
  const classes = useStyles();
  const { state } = useContext(ApplicationSummaryPageContext);
  const [value, setValue] = useState(0);
 
  const { hasPermission: hasConsentAccess } = useAuthorizer("applications_consent", "create");
  const [isResourceApplication, setIsResourceApplication] =
    useState<boolean>(true);

  const isConsentEnabled =  process.env.REACT_APP_CONSENT_WORKFLOW === "true";

  useEffect(() => {
    if(!setIsResourceApplication || !state?.application?.applicationType?.name) {
      return;
    }
    setIsResourceApplication(
      state?.application?.applicationType?.name !== "application"
    );
  }, [state, state?.application, state?.application?.applicationType?.name, setIsResourceApplication]);
  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  if (!state) {
    return <Alert severity="warning">No application data available</Alert>;
  }
  const canShowResourceApp =
    process.env.REACT_APP_NEW_RESOURCE_APP_CREATION === "true";

  return (
    <Container maxWidth={false} className={classes.container}>
      <>
        {state.application && (
          <div className={classes.root}>
            <Tabs
              value={value}
              onChange={handleChange}
              className={classes.tabs}
              indicatorColor="primary"
            >
              <Tab className={classes.tab} label="OVERVIEW" key="overview" />
                
                <Tab
                className={classes.tab}
                label="GRANT TYPES"
                key="grant_types"
                />
                <Tab
                className={classes.tab}
                label="SUBSCRIPTIONS"
                key="subscriptions"
              />

              {isConsentEnabled && hasConsentAccess &&(
                <Tab
                  className={classes.tab}
                  label="CONSENTS"
                  key="consents"
                  tabIndex={3}
                />
              )}

            </Tabs>

            <TabPanel value={value} index={0}>
              <Box className={classes.tabPanel}>
                <ApplicationOverviewTab state={state} />
              </Box>
            </TabPanel>
            <TabPanel value={value} index={1}>
              <Box className={classes.tabPanel}>
                <GrantTypesForm 
                    reloadApplication={reloadApplication  as any}
                    state={state} 
                    existingGrantTypes={state?.application?.applicationGatewayResponses?.[0]?.grantTypes}/>
              </Box>
            </TabPanel>
            
            <TabPanel value={value} index={2}>
              <Box className={classes.tabPanel}>
                {state?.application && (
                  <SubscriptionsList application={state?.application} consumerKey={state?.application?.applicationGatewayResponses?.[0]?.consumerKey as string} />
                )}
              </Box>
            </TabPanel>
            {isConsentEnabled && (
              <TabPanel value={value} index={3}>
                <ConsentForm
                  application={state?.application}
                  reloadApplication={reloadApplication as any}
                />
              </TabPanel>
            )}

          </div>
        )}
      </>
    </Container>
  );
};

export default ApplicationSummaryDetailView;
